var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00109627 8.6816C0.0734503 6.18426 0.895656 4.19296 2.52033 2.55654C3.86217 1.20272 5.5 0.374653 7.39437 0.0986316C9.57156 -0.216822 11.5909 0.223499 13.4261 1.43274C15.2875 2.66169 16.5176 4.37697 17.0569 6.54572C17.6555 8.95762 17.2806 11.2315 15.9453 13.328C13.7944 16.6994 11.6238 20.0642 9.45974 23.4356C9.42028 23.5013 9.38081 23.5671 9.32819 23.6328C8.973 24.1191 8.34812 24.1257 7.99951 23.6328C7.75614 23.291 7.54565 22.9296 7.31543 22.5747C5.32241 19.4727 3.32938 16.3708 1.34294 13.2622C0.422065 11.8033 -0.0252143 10.2129 0.00109627 8.6816ZM12.6039 8.64874C12.6039 6.48 10.8279 4.71214 8.65727 4.71214C6.49981 4.71871 4.737 6.48 4.72384 8.6356C4.71727 10.7978 6.48665 12.5788 8.65727 12.5853C10.8279 12.5853 12.6039 10.8109 12.6039 8.64874Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocation);
export default __webpack_public_path__ + "static/media/pin-location.bf29e0de2502873e60de4594d6f1c37f.svg";
export { ForwardRef as ReactComponent };